/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AnonymousParentEntityIdForHostnameGet$Params {
  hostName?: string;
}

export function anonymousParentEntityIdForHostnameGet(http: HttpClient, rootUrl: string, params?: AnonymousParentEntityIdForHostnameGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, anonymousParentEntityIdForHostnameGet.PATH, 'get');
  if (params) {
    rb.query('hostName', params.hostName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<string>;
    })
  );
}

anonymousParentEntityIdForHostnameGet.PATH = '/Anonymous/ParentEntityIdForHostname';
